import { FC, ReactElement } from 'react';
import { SfuModels, useParticipantViewContext } from '@stream-io/video-react-sdk';
import { Mic, MicMute } from 'react-bootstrap-icons';
import NetworkQualityBars from './NetworkQualityBars';

const ParticipantUIView: FC = (): ReactElement | null => {
  const { participant } = useParticipantViewContext();

  const isAudioMuted: boolean = !participant.publishedTracks.includes(SfuModels.TrackType.AUDIO);
  const name: string = participant.name || participant.userId || 'Teilnehmer';

  return (
    <div
      className="position-absolute bottom-0 start-0 w-100 d-flex align-items-end justify-content-between px-3 pb-3"
      style={{
        background: 'linear-gradient(to top, rgba(0,0,0,0.65) 0%, transparent 100%)',
        pointerEvents: 'none',
        paddingTop: '48px',
      }}
    >
      <div
        className="d-flex align-items-center gap-2 px-3 py-2 rounded-pill"
        style={{
          backgroundColor: 'rgba(0,0,0,0.55)',
          backdropFilter: 'blur(4px)',
          fontSize: '0.9rem',
          color: '#fff',
          maxWidth: '75%',
        }}
      >
        {isAudioMuted
          ? <MicMute size={14} style={{ color: '#f87171', flexShrink: 0 }} />
          : <Mic size={14} style={{ color: '#4ade80', flexShrink: 0 }} />
        }
        <span className="fw-semibold text-truncate">{name}</span>
      </div>
      
      <div
        className="d-flex align-items-center px-3 py-2 rounded-pill"
        style={{ backgroundColor: 'rgba(0,0,0,0.55)', backdropFilter: 'blur(4px)' }}
      >
        <NetworkQualityBars quality={participant.connectionQuality} size="sm" />
      </div>
    </div>
  );
};

export default ParticipantUIView;